import * as Constants from "../constants";
import {AxiosResponse} from "axios";
import {idlAPIClient} from "./axios";
import LoginRegistrationService from "./login-registration";

const ApiUtils = {
  getToken:  ():string => {
    const token: string | null = sessionStorage.getItem(Constants.SESSION_KEY_CSRF);
    if (!token) {
      const error: any = new Error();
      error.message = 'Not logged in';
      error.status = 403;
      throw error;
    }
    return token
  },


  makePut: async (data: any, url: string, tokenRequest: number = 0):Promise<any> => {
    try {
      const token: string = ApiUtils.getToken();
      const response: AxiosResponse<any, any> = await idlAPIClient.put<any>(
        url,
        data,
        {headers: {"x-csrf-token": token}});

      return response.data;

    } catch ( e: any ) {
      const error = JSON.parse(JSON.stringify(e))
      if (((error.status === 403) || (error.status === 401)) && (tokenRequest < 1)) {
        const token: string | null = await LoginRegistrationService.getToken();
        if (token) {
          return await ApiUtils.makePut(data, url, 1)
        }
      } else {
        throw error
      }
    }
  },

  makePatch: async (data: any, url: string, tokenRequest: number = 0):Promise<any> => {
    try {
      const token: string = ApiUtils.getToken();
        const response: AxiosResponse<any, any> = await idlAPIClient.patch<any>(
          url,
          data,
          {headers: {"x-csrf-token": token}});

        return response.data;

      } catch ( e: any ) {
        const error = JSON.parse(JSON.stringify(e))
        if (((error.status === 403) || (error.status === 401)) && (tokenRequest < 1)) {
          const token: string | null = await LoginRegistrationService.getToken();
          if (token) {
            return await ApiUtils.makePatch(data, url, 1)
          }
        } else {
          throw error
        }
      }
  },

  makePost: async (data: any, url: string, tokenRequest: number = 0):Promise<any> => {
    try {
      const token: string = ApiUtils.getToken();
      const response: AxiosResponse<any, any> = await idlAPIClient.post<any>(
        url,
        data,
        {headers: {"x-csrf-token": token}});

      return response.data;
    } catch ( e: any ) {
      const error = JSON.parse(JSON.stringify(e))
      if (((error.status === 403) || (error.status === 401)) && (tokenRequest < 1)) {
        const token: string | null = await LoginRegistrationService.getToken();
        if (token) {
          return await ApiUtils.makePost( data, url, 1)
        }
      } else {
        throw error
      }
    }
  },

  doDelete:  async (params: any, url: string, tokenRequest: number = 0):Promise<any> => {
    try {
      const token: string = ApiUtils.getToken();
      const response: AxiosResponse<any, any> = await idlAPIClient.delete<any>(
        url,
        {
          params,
          headers: {"x-csrf-token": token}});

      return response.data;

    } catch ( e: any ) {
      const error = JSON.parse(JSON.stringify(e))
      if (((error.status === 403) || (error.status === 401)) && (tokenRequest < 1)) {
        const token: string | null = await LoginRegistrationService.getToken();
        if (token) {
          return await ApiUtils.doDelete(params, url, 1)
        }
      } else {
        throw error
      }
    }
  }
}

export default ApiUtils;
